module.exports = __webpack_public_path__ + "img/ekomi_logo_v1.a372a29.png";